import api from '../api'

export const login = (params) => api.post('/auth/login', params)

export const getUserApplications = (params) => api.get('/admin/functionalities', { params })

export const getUserFarms = (params) => api.get('/companies/farms/my-access', { params })

export const getContexts = (params) => api.get('/admin/contexts', { params })
